module.exports = __webpack_public_path__ + "static/class-43221ee0dd170fd2ef8256593ef1ee42.jpg";